import React from 'react';
import { Box } from '@mui/material';
import { HeroSection } from './components';
import { BenefitsSection } from './components/benefits';
import { HowItWorks } from './components/howItWorks';
import { EarnPoints } from './components/earnPoints';
import { Levels } from './components/levels';
import { FaqSection } from './components/faq';
import { useLoyaltyPageContext } from './context';
import { CampaignsSection } from './components/cashbackProgram';

const LoyaltyPageContent: React.FC = () => {
  const {
    isLoggedIn,
    RedeemComponent,
    enabledSections,
    shouldRenderBenefits,
    showWelcomeGiftBenefit,
    tierConfig,
    cashbackProgram: {
      isCashbackProgram,
      liveCampaigns,
    },
  } = useLoyaltyPageContext();

  return (
    <Box>
      <Box bgcolor="background.paper">
        <Box>
          {enabledSections.heroSectionIsEnabled && (
            <HeroSection />
          )}
          {isLoggedIn && RedeemComponent}
        </Box>
        {
          (showWelcomeGiftBenefit || enabledSections.promoteCashbackIsEnabled || shouldRenderBenefits) && (
            <Box>
              <BenefitsSection />
            </Box>
          )
        }
      </Box>
      {
        enabledSections.howItWorksIsEnabled &&
        <HowItWorks />
      }

      {
        enabledSections.activeMissionsIsEnabled && (
          isCashbackProgram ? (!!liveCampaigns.length && <CampaignsSection />) : <EarnPoints />
        )
      }
      {
        enabledSections.levelsIsEnabled && tierConfig?.enabled && (
          <Levels />
        )
      }
      {
        enabledSections.faqIsEnabled && <FaqSection />
      }
    </Box>
  );
};

export default LoyaltyPageContent;
